{
  "title": "Audit log",
  "subtitle": "Who did what, and when: every change to the books and records, newest first.",
  "fields": {
    "when": "When",
    "action": "Action",
    "record": "Record",
    "actor": "By",
    "changes": "Changes",
    "ip": "IP address",
    "requestId": "Request reference"
  },
  "list": {
    "entityFilter": "Filter by record type",
    "allRecords": "All records",
    "actionFilter": "Filter by action",
    "allActions": "All actions",
    "searchRecords": "Search record types…",
    "searchActions": "Search actions…",
    "noMatch": "No matches.",
    "filterByActor": "Show only what {{name}} did",
    "actorChip": "By {{name}}",
    "recordChip": "This record only",
    "system": "System",
    "more_one": "+{{count}} more field",
    "more_other": "+{{count}} more fields",
    "empty": "Nothing has been recorded yet.",
    "emptyFiltered": "Nothing matches these filters.",
    "clearFilters": "Clear filters"
  },
  "detail": {
    "changes": "Changed fields",
    "context": "Details",
    "field": "Field",
    "before": "Before",
    "after": "After",
    "noChanges": "No field changes were recorded for this action."
  },
  "history": {
    "action": "History",
    "title": "History",
    "subtitle": "Who created, changed, posted or voided this record, newest first.",
    "empty": "No history recorded yet.",
    "more": "Show more"
  },
  "entity": {
    "SalesInvoice": "Sales invoice",
    "Quotation": "Quotation",
    "Receipt": "Receipt",
    "CreditNote": "Credit note",
    "CustomerRefund": "Customer refund",
    "Cheque": "Cheque",
    "Customer": "Customer",
    "CustomerGroup": "Customer group",
    "Purchase": "Purchase",
    "SupplierPayment": "Supplier payment",
    "SupplierReturn": "Supplier return",
    "SupplierRefund": "Supplier refund",
    "Supplier": "Supplier",
    "SupplierGroup": "Supplier group",
    "PosTerminal": "Till",
    "PosShift": "Till shift",
    "PosSale": "Till sale",
    "PosReturn": "Till return",
    "Product": "Product",
    "ProductCategory": "Product category",
    "ProductAttribute": "Product attribute",
    "Unit": "Unit",
    "CustomPrice": "Custom price",
    "Warehouse": "Warehouse",
    "StockAdjustment": "Stock adjustment",
    "StockTransfer": "Stock transfer",
    "Account": "Account",
    "AccountRoles": "Account mapping",
    "JournalEntry": "Journal entry",
    "FiscalYear": "Fiscal year",
    "TaxRate": "Tax rate",
    "TreasuryAccount": "Cash or bank account",
    "PaymentMethod": "Payment method",
    "TreasuryTransfer": "Cash or bank transfer",
    "BankStatement": "Bank statement",
    "BookFinding": "Books health finding",
    "Expense": "Expense",
    "ExpenseCategory": "Expense category",
    "RecurringExpense": "Recurring expense",
    "User": "User",
    "Role": "Role",
    "OrgUnit": "Org unit",
    "WorkLocation": "Work location",
    "CalendarHoliday": "Holiday",
    "Tenant": "Company",
    "CompanyProfile": "Company profile",
    "SalesSettings": "Sales settings",
    "SettingGroup": "Settings group",
    "TenantSecret": "Secret",
    "LockDate": "Lock date",
    "Workflow": "Approval workflow",
    "WorkflowRun": "Approval request",
    "WorkflowDelegation": "Approval delegation",
    "Message": "Message",
    "MessageTemplate": "Message template",
    "MessageOptOut": "Message opt-out",
    "IssuedDocument": "Issued PDF",
    "PublicLink": "Share link",
    "RetentionRule": "Retention rule",
    "LegalHold": "Legal hold",
    "PrivacyRequest": "Privacy request",
    "PrivacySubject": "Personal data",
    "UserInvitation": "User invitation",
    "Task": "Task",
    "TaskTeam": "Team",
    "ServiceJob": "Service job",
    "ServiceVisit": "Service visit",
    "ServiceFollowUp": "Follow-up request",
    "ServiceCollection": "Collection",
    "ServiceSite": "Service site",
    "ServicePlace": "Place in a site",
    "ServiceSiteTemplate": "Site template",
    "ServiceAsset": "Asset",
    "ServiceAssetType": "Asset type",
    "ServiceContract": "Maintenance contract",
    "Project": "Project",
    "ProjectType": "Project type",
    "ProjectCostCategory": "Cost category",
    "ProjectCostCategoryMap": "Cost category mapping",
    "ProjectCostEntry": "Cost entry",
    "ProjectMaterialIssue": "Material issue",
    "ProjectRole": "Rate role",
    "ProjectPersonRate": "Hourly cost",
    "ProjectTimeEntry": "Time entry",
    "ProjectStatusReport": "Status report",
    "ProjectVariation": "Variation",
    "ProjectClaim": "Progress claim",
    "ProjectGuarantee": "Guarantee",
    "AiSettings": "AI assistant settings",
    "AiConversation": "Assistant conversation",
    "AiRun": "Assistant run",
    "LoyaltyProgram": "Loyalty programme",
    "LoyaltyTier": "Loyalty tier",
    "LoyaltyRule": "Loyalty bonus rule",
    "LoyaltyMember": "Loyalty member",
    "issued_document": "Issued PDF",
    "Employee": "Employee",
    "EmployeeDocument": "Employee document",
    "PayComponent": "Pay component",
    "PayrollSettings": "Payroll settings",
    "ContributionRule": "Contribution rule",
    "PayrollRun": "Payroll run",
    "CommissionPlan": "Commission plan",
    "CommissionRun": "Commission run"
  },
  "action": {
    "CREATE": "Created",
    "UPDATE": "Changed",
    "DELETE": "Deleted",
    "POST": "Posted",
    "VOID": "Voided",
    "ALLOCATE": "Applied",
    "UNALLOCATE": "Unapplied",
    "APPROVE": "Approved",
    "REJECT": "Rejected",
    "CONVERT": "Converted",
    "ARCHIVE": "Archived",
    "RESTORE": "Restored",
    "SET_MAIN": "Made main",
    "OPEN": "Opened",
    "CLOSE": "Closed",
    "REOPEN": "Reopened",
    "REVERSE": "Reversed",
    "MATCH": "Matched",
    "UNMATCH": "Unmatched",
    "ADJUST": "Adjustment posted",
    "COMPLETE": "Completed",
    "PAY_IN": "Cash paid in",
    "PAY_OUT": "Cash paid out",
    "LOGIN": "Signed in",
    "LOGIN_FAILED": "Sign-in failed",
    "LOGIN_LOCKED": "Locked out",
    "LOGOUT": "Signed out",
    "UNLOCK": "Unlocked",
    "PASSWORD_CHANGE": "Password changed",
    "PASSWORD_RESET": "Password reset",
    "SET": "Set",
    "ATTACH": "File attached",
    "DETACH": "File removed",
    "SUBMIT": "Submitted for approval",
    "RETURN": "Returned for changes",
    "WITHDRAW": "Withdrawn",
    "CANCEL": "Cancelled",
    "REASSIGN": "Reassigned",
    "REFRESH_APPROVERS": "Approvers refreshed",
    "RETRY": "Retried",
    "ACTION_FAILED": "Final action failed",
    "SAVE_DRAFT": "Draft saved",
    "DISCARD_DRAFT": "Draft discarded",
    "PUBLISH": "Published",
    "ENABLE": "Enabled",
    "DISABLE": "Disabled",
    "REORDER": "Order changed",
    "DUPLICATE": "Duplicated",
    "REVOKE": "Revoked",
    "MOVE": "Moved",
    "EMAILED": "E-mailed",
    "ISSUE": "Issued",
    "INVITED": "Invitation sent",
    "INVITATION_ACCEPTED": "Invitation accepted",
    "EXPORT": "Exported",
    "IMPORT": "Imported",
    "ANONYMISE": "Anonymised",
    "LIFT": "Lifted",
    "VERIFY": "Identity verified",
    "START": "Started",
    "REFUSE": "Refused",
    "MIGRATE": "Data brought from the old system",
    "ACTIVATE": "Activated",
    "IMPERSONATION_START": "Support signed in as the user",
    "MARK_LOST": "Marked lost",
    "START_PROJECT": "Project started from it",
    "COMMIT": "Committed to To do",
    "BACKLOG": "Moved to backlog",
    "PAUSE": "Paused",
    "ACCEPT": "Work accepted",
    "ASSIGN": "Assigned",
    "CLAIM": "Taken from the team queue",
    "BLOCK": "Marked blocked",
    "UNBLOCK": "Unblocked",
    "REQUEST_DATE": "New due date requested",
    "ADD_PERSON": "Person added",
    "REMOVE_PERSON": "Person removed",
    "LINK": "Record linked",
    "UNLINK": "Linked record removed",
    "WAITING": "Waiting status changed",
    "ITEM_ADD": "Item added",
    "ITEM_UPDATE": "Item changed",
    "ITEM_REMOVE": "Item removed",
    "PRICE_APPROVAL": "Price approval recorded",
    "SCHEDULE": "Visit scheduled",
    "RESCHEDULE": "Visit rescheduled",
    "BEGIN_WORK": "Work begun",
    "WORK": "Work recorded",
    "FINISH": "Visit finished",
    "REQUEST": "Follow-up requested",
    "RESUBMIT": "Sent again",
    "INVOICE": "Invoiced",
    "REPORT": "Collection reported",
    "GENERATE_PLACES": "Places generated",
    "DUPLICATE_PLACE": "Place duplicated",
    "ASSETS_ADD": "Assets added",
    "ASSETS_COPY": "Assets copied",
    "ASSETS_IMPORT": "Assets imported",
    "STATUS": "Status changed",
    "REPLACE": "Replaced",
    "HOLD": "Put on hold",
    "RESUME": "Resumed",
    "UPDATE_FEATURES": "Functions changed",
    "ADD_MEMBER": "Team member added",
    "UPDATE_MEMBER": "Team member changed",
    "REMOVE_MEMBER": "Team member removed",
    "ADD_NOTE": "Note added",
    "PIN_NOTE": "Note pinned",
    "UNPIN_NOTE": "Note unpinned",
    "REMOVE_NOTE": "Note removed",
    "ADD_PRESETS": "Standard types added",
    "ADD_NODE": "Plan node added",
    "UPDATE_NODE": "Plan node changed",
    "MOVE_NODE": "Plan node moved",
    "REMOVE_NODE": "Plan node removed",
    "ACHIEVE_MILESTONE": "Milestone achieved",
    "UNACHIEVE_MILESTONE": "Milestone taken back",
    "PROGRESS": "Progress updated",
    "APPLY_TEMPLATE": "Plan created from a template",
    "PLACE_TASK": "Task placed in the plan",
    "APPLY_PLAN": "Assistant’s plan applied",
    "BUDGET_CREATE": "Budget created",
    "BUDGET_UPDATE": "Budget changed",
    "BUDGET_DELETE": "Budget deleted",
    "BUDGET_SUBMIT": "Budget submitted for approval",
    "BUDGET_APPROVE": "Budget approved",
    "BUDGET_RETURN": "Budget returned for changes",
    "BILLING_ITEM_CREATE": "Billing item added",
    "BILLING_ITEM_UPDATE": "Billing item changed",
    "BILLING_ITEM_DELETE": "Billing item deleted",
    "BILLING_ITEM_CANCEL": "Billing item cancelled",
    "BILLING_ITEM_READY": "Billing item marked ready",
    "BILLING_ITEM_UNREADY": "Billing item marked not ready",
    "BILLING_ITEMS_ORDER": "Billing items reordered",
    "BILLING_OVERRIDE": "Billable work adjusted",
    "BILL": "Billed",
    "BILL_VOID": "Billing voided",
    "ADD_RATE": "Hourly cost added",
    "REPLACE_RATE": "Hourly cost replaced",
    "SIGNAL_ACKNOWLEDGE": "Alert acknowledged",
    "SIGNAL_UNACKNOWLEDGE": "Alert acknowledgement removed",
    "REFRESH_FIGURES": "Figures refreshed",
    "FINALISE": "Finalised",
    "CONTRACT_CREATE": "Contract created",
    "CONTRACT_UPDATE": "Contract changed",
    "CONTRACT_ACTIVATE": "Contract activated",
    "CONTRACT_AMEND": "Contract amended",
    "CONTRACT_PRACTICAL_COMPLETION": "Practical completion recorded",
    "CONTRACT_CLOSE": "Contract closed",
    "CONTRACT_ADVANCE": "Advance invoiced",
    "CONTRACT_ADVANCE_VOID": "Advance voided",
    "CONTRACT_ADVANCE_REDUCE": "Advance reduced",
    "CONTRACT_ADVANCE_REDUCE_VOID": "Advance reduction voided",
    "BOQ_VERSION_CREATE": "BOQ version created",
    "BOQ_VERSION_UPDATE": "BOQ version changed",
    "BOQ_VERSION_DELETE": "BOQ version deleted",
    "BOQ_IMPORT": "BOQ imported",
    "BOQ_BUDGET": "Budget created from the BOQ",
    "VARIATION_CREATE": "Variation created",
    "VARIATION_UPDATE": "Variation changed",
    "VARIATION_REQUEST_APPROVAL": "Variation sent for internal approval",
    "VARIATION_APPROVE_INTERNAL": "Variation approved internally",
    "VARIATION_RETURN_INTERNAL": "Variation returned internally",
    "VARIATION_SUBMIT": "Variation submitted to the client",
    "VARIATION_APPROVE": "Variation approved",
    "VARIATION_REJECT": "Variation rejected",
    "VARIATION_WITHDRAW": "Variation withdrawn",
    "CLAIM_CREATE": "Claim created",
    "CLAIM_UPDATE": "Claim changed",
    "CLAIM_DELETE": "Claim deleted",
    "CLAIM_REQUEST_APPROVAL": "Claim sent for internal approval",
    "CLAIM_APPROVE_INTERNAL": "Claim approved internally",
    "CLAIM_RETURN_INTERNAL": "Claim returned internally",
    "CLAIM_SUBMIT": "Claim submitted to the client",
    "CLAIM_REJECT": "Claim rejected",
    "CLAIM_CERTIFIED_FIGURES": "Certified figures entered",
    "CLAIM_CERTIFY": "Claim certified",
    "CLAIM_VOID": "Claim voided",
    "RETENTION_RELEASE": "Retention released",
    "RETENTION_RELEASE_VOID": "Retention release voided",
    "RETENTION_FORFEIT": "Retention forfeited",
    "RETENTION_FORFEIT_VOID": "Retention forfeit voided",
    "GUARANTEE_CREATE": "Guarantee added",
    "GUARANTEE_UPDATE": "Guarantee changed",
    "GUARANTEE_EVENT": "Guarantee event recorded",
    "GUARANTEE_EXPIRE": "Guarantee expired",
    "DISMISS": "Finding dismissed",
    "UNDISMISS": "Dismissal ended",
    "KEY_CHECK": "API key checked",
    "RUN": "Assistant run",
    "SKIP": "Date skipped",
    "RUN_NOW": "Next date created early",
    "END": "Ended",
    "ENROLL": "Enrolled",
    "TERMINATE": "Terminated",
    "RENEW": "Renewed",
    "EXPIRE": "Expired",
    "PLAN_ADD": "Plan added",
    "PLAN_UPDATE": "Plan changed",
    "GENERATE": "Planned jobs made",
    "CHECK": "Asset checked",
    "FAULT": "Fault job opened",
    "BILLING_REBUILD": "Instalments rebuilt",
    "DEPOSIT": "Deposited",
    "CLEAR": "Cleared",
    "BOUNCE": "Bounced",
    "HAND_BACK": "Handed back",
    "CHARGEBACK": "Returned by the bank",
    "UNDO": "Undone"
  },
  "redacted": {
    "label": "Redacted",
    "why": "Removed under the data retention policy"
  }
}
